let audioContext: AudioContext | null = null;
let isMute: boolean = false;

export function initAudioContext() {
  if (!audioContext) {
    audioContext = new AudioContext();
    audioContext.resume();
    const mp3Names = ["attack", "cardpick1", "cardput1", "cardturnover1", "alert", "failed"];
    mp3Names.forEach((name) => {
      loadMP3(name);
    });
  }
}

const seBuffers: Record<string, AudioBuffer> = {};

interface PlayingBGM {
  source: AudioBufferSourceNode;
  gainNode: GainNode;
  name: string;
}

let currentBGM: PlayingBGM | null = null;

async function loadMP3(name: string) {
  const res = await fetch(`${process.env.PUBLIC_URL}/sound/${name}.mp3`);
  const arrayBuffer = await res.arrayBuffer();
  seBuffers[name] = await audioContext!.decodeAudioData(arrayBuffer);
}

export function playSE(name: string) {
  const buffer = seBuffers[name];
  if (!buffer || !audioContext) return;

  const source = audioContext.createBufferSource();
  source.buffer = buffer;

  const gainNode = audioContext.createGain();

  const now = audioContext.currentTime;
  const baseVolume = isMute ? 0 : 0.1;
  gainNode.gain.setValueAtTime(baseVolume, now);

  source.connect(gainNode);
  gainNode.connect(audioContext.destination);

  source.onended = () => {
    source.disconnect();
    gainNode.disconnect();
  };
  source.start(now);
}

/**
 * 音量変更
 */
export function toggleMute() {
  isMute = !isMute;

  if (!audioContext) return isMute;

  // 現在BGMがある場合のみ音量を変更
  if (currentBGM) {
    const now = audioContext.currentTime;
    const gain = currentBGM.gainNode.gain;
    gain.cancelScheduledValues(now);

    if (isMute) {
      gain.linearRampToValueAtTime(0, now + 0.05);
    } else {
      gain.linearRampToValueAtTime(0.1, now + 0.2);
    }
  }

  return isMute;
}
